import {
  Directive,
  ViewContainerRef,
  TemplateRef,
  Input
} from '@angular/core';
import { LogService } from '../../shared/log/log.service';
import { AuthenticationStore } from '../services/authentication.store';
import { AuthorizationModel } from '../models/authorize.model';
import { TranslateService } from '@ngx-translate/core';

/**
 *
 @example <caption>Example usage of AuthorizeDirective.</caption>
 * <div *pioneerAuthorize="{permission: 'AddEvent'}"></div>
 * and
 * <div *pioneerAuthorize="{permissions: ['AddEvent', 'EditEvent']}"></div>
 */
@Directive({
  selector: '[pioneerAuthorize]'
})
export class AuthorizeDirective {

  constructor(private viewContainer: ViewContainerRef,
              private template: TemplateRef<any>,
              private authStore: AuthenticationStore,
              private translateService: TranslateService,
              private logService: LogService) {

  }

  @Input('pioneerAuthorize') set authorize(authorizationModel: AuthorizationModel) {
    // this.logService.info('authorize - authorizationModel: ' + JSON.stringify(authorizationModel));

    if (this.authStore.hasPermission(this.getPermissions(authorizationModel))) {
      this.logService.verbose('show me');
      this.viewContainer.createEmbeddedView(this.template);
    } else {
      this.logService.verbose('hide me');
      this.viewContainer.clear();
    }
  }

  private getPermissions(authorizationModel: AuthorizationModel): string[] {

    if (authorizationModel.permission) {
      return Array.of(authorizationModel.permission.toLowerCase());
    } else if (authorizationModel.permissions) {
      return authorizationModel.permissions.map(perm => perm.toLowerCase());
    } else {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.INVALID_AUTHORIZE_FORMAT'));
    }
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/permission/directive/authorization-directive.ts